// Third-party
import React from 'react';

// Components
import FlagLabel from './FlagLabel';

// Utils
import { getCurrencyColor, currencyToText } from '../../../utils/currency';

type Props = {
  currency: string;
};

const CurrencyLabel = ({ currency }: Props) => <FlagLabel className="currency-label" text={currencyToText(currency)} color={getCurrencyColor(currency)} />;

export default CurrencyLabel;
